/**
 * Pie series style overrides.
 *
 * Applies donut vs solid, inner/outer radius, rose type, and label position.
 */
import type { EChartsOption } from 'echarts';
import type { TypeStyle } from '../../../../../edit/visualConfig';

export function applyPieOverrides(option: EChartsOption, cs: TypeStyle): EChartsOption {
  if (!Array.isArray(option.series)) return option;

  const result = { ...option };
  result.series = (result.series as any[]).map((s: any) => {
    if (s.type !== 'pie') return s;

    const outerVal = cs.outerRadius ?? 70;
    // Ensure inner is always less than outer to avoid invalid ECharts config
    const innerVal = cs.donut ? Math.min(cs.innerRadius ?? 40, outerVal - 5) : 0;
    const inner = `${Math.max(innerVal, 0)}%`;
    const outer = `${outerVal}%`;

    return {
      ...s,
      radius: [inner, outer],
      roseType: cs.sortSlices ? 'area' : undefined,
    };
  });

  return result;
}